import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { OtpComponent } from './otp.component';

@NgModule({
    declarations: [
        OtpComponent
    ],
    imports: [
        CommonModule,
        FormsModule
    ],
    exports: [
        OtpComponent
    ]
})
export class NcOtpModule { }